import { ETagVariant, Tag } from '@outdoorsyco/bonfire';
import React, { memo } from 'react';
import { useIntl } from 'react-intl';

import { TAutoRentalTile } from '@/utility/mapAutoSearchResultToTile';
import { ISearchResultTile } from '@/utility/mapSearchResultToTile';

type TListingTileRebookProps = {
  listingTile: ISearchResultTile | TAutoRentalTile;
};

export const ListingTileRebook = memo(function ListingTileRebook({
  listingTile: { wasBookedBefore = false },
}: TListingTileRebookProps) {
  const intl = useIntl();

  if (!wasBookedBefore) return null;

  return (
    <div style={{ '--bf-tag-text-typography-text-case': 'uppercase' } as React.CSSProperties}>
      <Tag
        variant={ETagVariant.White}
        label={intl.formatMessage({
          defaultMessage: 'Rebook',
          id: 'Yqh1DM',
        })}
      />
    </div>
  );
});
